export default "__VITE_ASSET__CrLCIDrW__"